import { useState } from "react"
import {useGetFriendsQuery, useGetUsersQuery} from "../features/users/usersApiSlice"
import useAuth from "../hooks/useAuth"
export const FriendsCheckbox = ({friends, setFriends, group, label = "עבדתן יחד? סמני את החברה איתה עבדת"}) => {
    const [q, setQ] = useState("")
    const {friends:defaultFriends, isAdmin} = useAuth()
    const {data, isError, isLoading, isUninitialized, skip} = useGetFriendsQuery(undefined, { skip:isAdmin })
    const {data:dataAdmin, isError:isErrorAdmin, isLoading:isLoadingAdmin, isUninitialized:isUninitializedAdmin} = useGetUsersQuery(undefined,{ skip:!isAdmin })

    const changeFriend = (e) =>{
        const userId = e.target.value
        const updateFriends = (e.target.checked===false)? friends.filter(friend=> friend !== userId) : [...friends, userId]
        setFriends(updateFriends)
        setQ("")
    }
    if ( !isAdmin && (  isLoading || isUninitialized)) return <h1>Loading</h1>
    if ( isAdmin && ( isLoadingAdmin || isUninitializedAdmin)) return <h1>Loading</h1>
    if( !isAdmin && !data.length) return <h1>No friends</h1>
    if( isAdmin  && !dataAdmin && !dataAdmin?.ids?.length) return <h1>No friends</h1>
    let friendsInGroup
    if(!isAdmin){
    friendsInGroup = data.filter(user=> ( !group || (user.groups.includes(group) )&& (!q || user.name.indexOf(q) > -1)))
    if(friends && friends.length){
        friendsInGroup = friendsInGroup.map(friend => friends.includes(friend._id)? {...friend, checked: true}  : {...friend})
    }
    friendsInGroup  =friendsInGroup.sort((a,b)=> Number( b.checked || 0) -  Number(a.checked || 0))
    }else{
      const { ids , entities} = dataAdmin

      const newIds =  ids.filter(id=>{
        const user = entities[id]
            if( (q==='' || (user.name.toLowerCase().indexOf(q) > -1 ))
               && (!group ||  user.groups?.includes(group)))
                return true
            else
                return false
        })
        friendsInGroup = newIds.map(id=> {
          const f = {...entities[id]}
          if (friends.includes(id)) f.checked = true
          return f
        } )
        friendsInGroup  =friendsInGroup.sort((a,b)=> Number( b.checked || 0) -  Number(a.checked || 0))
       

    }
    //אם לא קיימים חברים למיין לפי החברים הקיימים שנבחרו
    if(!friends?.length && group && defaultFriends ){
      const groupExists = defaultFriends.friends.find(friendObj=> friendObj.group === group)
      if(groupExists){
        const getCount = (friend) =>{
          const u = groupExists.groupFriends.find(gf=>gf.friend === friend._id) 
          if(u && u.count) return u.count 
          return 0
        }
        friendsInGroup  =friendsInGroup.sort((a,b)=> getCount(b) -  getCount(a) )
      }
    }
  return (
    <div className="friends-wrapper">
        <label>{label}</label>
        <input value={q} className="form__input" type="text" placeholder="חיפוש, כתבי את שם החברה " onChange={(e)=>setQ(e.target.value)} />
        <div className="friend-list">
        {friendsInGroup.map(friend=>{
           return <div key={friend._id}>  <input value={friend._id}  disabled={friends.length > 2 && !friend.checked} type="checkbox" onChange={changeFriend} defaultChecked={friend.checked} /> {friend.name} </div>
        })}
        </div>
        <span>נבחרו <span className="badge"> {friends.length} </span> חברות - לא ניתן לבחור יותר מ-3 חברות</span>
    </div>
  )
}
